export default __webpack_public_path__ + "static/media/home-interior-design-testimonial-img02.dae9db23.jpg";